import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, CardTitle, Drawer, Text } from '@reveni-io/reveni-ui'

import RefundMethodSelector from '@/returns/components/RefundMethodSelector/RefundMethodSelector'

import * as Styles from './styles'

const ChangeRefundMethodDrawer = ({
  show,
  onClose,
  refundMethods,
  refundMethodSelected,
  currentRefundMethod,
  onChangeRefundMethod,
  onSave,
  loading,
  allowsEditRefundMethod,
}) => {
  const { t } = useTranslation()

  const isSaveDisabled = loading || refundMethodSelected === currentRefundMethod

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Cambiar método de reembolso')}</CardTitle>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Selecciona el método de reembolso que se usará cuando se emita el reembolso. No se emitirá el reembolso al guardar cambios.'
          )}
        </Text>
        <RefundMethodSelector
          refundMethods={refundMethods}
          refundMethodSelected={refundMethodSelected}
          onChange={onChangeRefundMethod}
          disabled={!allowsEditRefundMethod}
        />
        <Styles.ButtonsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          {allowsEditRefundMethod && (
            <ButtonWithSpinner
              fullWidth
              defaultLabel={t('Guardar')}
              loadingLabel={t('Guardando')}
              onClick={onSave}
              loading={loading}
              disabled={isSaveDisabled}
            />
          )}
        </Styles.ButtonsContainer>
      </Styles.MainContainer>
    </Drawer>
  )
}

export default ChangeRefundMethodDrawer
